import Link from "next/link";
import { usePathname, useRouter } from "next/navigation";
import React from "react";
import { useEventDetailsPageStore } from "~/state/store";
import { cn } from "~/utils/fontsConfig";

export type SubNavigationItemType = {
    name: string;
    icon: React.ReactNode;
    href?: string;
    onClick?: (e: React.MouseEvent<HTMLElement>) => void;
    postFixElement?: React.ReactNode;
    disabled?: boolean;
};

const SubNavigationItem = ({
    name,
    icon,
    href,
    onClick,
    postFixElement,
    disabled,
}: SubNavigationItemType) => {
    const router = useRouter();
    const pathname = usePathname() ?? "";

    const normalizePath = (path?: string) => {
        if (!path) {
            return;
        } else {
            return path?.replace(/^\/v3/, "");
        }
    };

    const isSelected = normalizePath(pathname) === normalizePath(href);

    const handleClick = () => {
        if (href) {
            // setIsSidebarVisible(false);

            if (isSelected) {
                // remove the last route from the stack and navigate to that
                router.push(pathname.split("/").slice(0, -1).join("/"));
            } else {
                router.push(href);
            }
        }
    };

    if (href) {
        return (
            <Link
                className={cn(
                    "flex flex-row items-center gap-1",
                    isSelected ? "text-white" : "text-v3-N-300",
                    "hover:cursor-pointer hover:text-white",
                )}
                onBeforeInput={handleClick}
                href={href}
            >
                <span className="flex h-6 w-6 items-center justify-center">
                    {icon}
                </span>
                <p className="">{name}</p>
            </Link>
        );
    }

    return (
        <div
            className={cn(
                "flex flex-row items-center justify-between", // Maintains space between main content and postfix element
                isSelected ? "text-white" : "text-v3-N-300",
                "hover:cursor-pointer hover:text-white",
                disabled ? "opacity-50 hover:cursor-not-allowed" : "",
            )}
            onClick={onClick}
        >
            <div className="flex flex-row items-center">
                <span className="flex h-6 w-6 items-center justify-center">
                    {icon}
                </span>
                <p className="">{name}</p>
            </div>
            {postFixElement && (
                <span className="flex h-6 w-6 items-center justify-center">
                    {postFixElement}
                </span>
            )}
        </div>
    );
};

export default SubNavigationItem;
